export default function callbackForm() {
  const locale  = document.documentElement.lang || 'ro'
  const baseUrl = locale !== 'ro' ? `/${locale}` : ''

  return {
    phone: '',
    loading: false,
    error: '',
    isDialogOpen: {
      successDialog: false,
      errorDialog: false
    },

    openDialog(dialog) {
      this.isDialogOpen[dialog] = true
    },
    closeDialog(dialog) {
      this.isDialogOpen[dialog] = false
    },

    async onSubmit() {
      this.loading = true
      this.error = ''

      try {
        await axios.post(`${baseUrl}/product/callback`, {
          phone: this.phone.replace(/\s/g, ''),
        })

        this.openDialog('successDialog')
        this.phone = ''
      } catch (e) {
        if (e.response?.status === 422) {
          this.error = Object.values(e.response.data.errors)[0][0]
        } else {
          this.openDialog('errorDialog')
        }
      } finally {
        this.loading = false
      }
    }
  }
}
